"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BNBUnfiToken = exports.BNBUpToken = exports.BNBWrappedToken = exports.BNBNativeToken = void 0;
const utils_1 = require("@unifiprotocol/utils");
exports.BNBNativeToken = new utils_1.Currency("BNB", 18, "BNB", "BNB");
exports.BNBWrappedToken = new utils_1.Currency("0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c", 18, "WBNB", "Wrapped BNB");
exports.BNBUpToken = new utils_1.Currency("0xb4E8D978bFf48c2D8FA241C0F323F71C1457CA81", 18, "UP", "UP");
exports.BNBUnfiToken = new utils_1.Currency("0x728C5baC3C3e370E372Fc4671f9ef6916b814d8B", 18, "UNFI", "UNFI");
